import ApiUtil from '@/api/api.util'
import ApiConfig from '@/api/api.config'
import index from "vuex";
import EtnersCommonUtil from '@/common/etners.common.util'

const eklDomain = ApiConfig.eklDomain

const codeRequestStoreModule = {
  state: {
    dataSource: {
      lastRequestParameters: {},
    },
    search: {
      button: {
        useYn: {
          type: 'radio',
          data: [],
          index: 0,
        },
        aplYn: {
          type: 'radio',
          data: [],
          index: 0,
        },
      },
      combobox: {
        authNm: {
          type: 'combobox',
          data: [],
          index: 0
        },
        status: {
          type: 'combobox',
          data: [],
          index: 0
        },
        logisticsCd:{
          type:'combobox',
          data:[],
          index: 0
        },
        zoneNmList: {
          type:'combobox',
          data:[],
          index: 0
        },
        cmpyNmForUser: {
          type: 'combobox',
          data: [],
          index: 0
        },
      },
    },
  },
  getters: {},
  mutations: {
    setAuthNmData(state, data) {
      state.search.combobox.authNm.data = data
    },
    setAuthNmIndex (state, index) {
      state.search.combobox.authNm.index = index
    },
    setLogisticsCdData(state, data){
      state.search.combobox.logisticsCd.data = data
    },
    setLogisticsCdIndex(state, index){
      state.search.combobox.logisticsCd.index = index
    },
    setZoneNmListData(state, data){
      state.search.combobox.zoneNmList.data = data
    },
    setZoneNmListIndex(state, index){
      state.search.combobox.zoneNmList.index = index
    },
    setCmpyNmForUserData(state, data) {
      state.search.combobox.cmpyNmForUser.data = data
    },
    setCmpyNmForUserIndex (state, index) {
      state.search.combobox.cmpyNmForUser.index = index
    },
  },

  actions: {

    /**********************************************************************
     * [주의사항]
     * actions 안에 정의하는 함수는 모듈별로 네임스페이스를 구분하지 않으므로,
     * 다른 모듈에서 사용하는 이름을 중복으로 사용하지 않아야 합니다.
     *
     * vue 모듈 안의 함수에서는 다음과 같이 호출이 가능합니다.
     *
     * this.$store.dispatch('initSearchData')
     *********************************************************************/

    /**
     * 페이지 로딩시 최초로 검색창 세팅.
     * 데이터를 ajax로 가져와서 세팅해야합니다.
     */
    initSearchData (context) {
      const param = {
        loginUserToken: sessionStorage.getItem('loginUserToken')
      }

      /** 권한 리스트 */
      const authNmUrl = `${eklDomain}/v1/ebmp/ai/manager/portal/user/authList.json`
      ApiUtil.post(authNmUrl, param).then(response => {
        const resultData = response.data.resultData
        context.commit('setAuthNmData', resultData)

        if (EtnersCommonUtil.isNotEmpty(resultData)) {
          for (let i = 0; i < resultData.length; i++) {
            const code = resultData[i]

            if (code.selected === true) {
              context.commit('setAuthNmIndex', i)
            }
          }
        }
      })
    },
    initLogisticsData (context) {
      const param = {
        loginUserToken: sessionStorage.getItem('loginUserToken')
      }

      /** 사내 물류 code 리스트 */
      const logisticsCdUrl = `${eklDomain}/v1/ebmp/ai/manager/portal/code/logisticsCdDtlList.json`
      ApiUtil.post(logisticsCdUrl, param).then(response => {
        const resultData = response.data.resultData.codeDtlInfoList
        context.commit('setLogisticsCdData', resultData)

        for (let i = 0; i < resultData.length; i++) {
          const code = resultData[i]
          if (code.selected == true) {
            context.commit('setLogisticsCdIndex', i)
          }
        }
      })

      /** 사내 물류 사업장 code 리스트 */
      const zoneNmListUrl = `${eklDomain}/v1/ebmp/ai/manager/portal/zone/zoneNmList.json`
      ApiUtil.post(zoneNmListUrl, param).then(response => {
        const resultData = response.data.resultData
        context.commit('setZoneNmListData', resultData)

        for (let i = 0; i < resultData.length; i++) {
          const code = resultData[i]
          if (code.selected == true) {
            context.commit('setZoneNmListIndex', i)
          }
        }
      })

      /** 회사명 리스트 */
      const cmpyNmForUserUrl = `${eklDomain}/v1/ebmp/ai/manager/portal/company/cmpyListForUserMgt.json`
      ApiUtil.post(cmpyNmForUserUrl, param).then(response => {
        const resultData = response.data.resultData
        if(EtnersCommonUtil.isNotEmpty(resultData)) {
        for (let i = 0; i < resultData.length; i++) {
          if(EtnersCommonUtil.isNotEmpty(resultData[i].corporateRegNo)){
            resultData[i].corporateRegNo = resultData[i].corporateRegNo.replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3')
          }
        }
        context.commit('setCmpyNmForUserData', resultData)

          for (let i = 0; i < resultData.length; i++) {
            const code = resultData[i]
            if (code.selected === true) {
              context.commit('setCmpyNmForUserIndex', i)
            }
          }
        }
      })
    },
  }
}

export default codeRequestStoreModule
